import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { Column, Query, QueryResult } from 'material-table';
import { IOverrideEntityActions } from '../../API/Interfaces/IEntityActions';
import ISearchBaseDto from '../../API/Interfaces/ISearchBaseDto';
import EntityPage from '../../Layout/EntityPage';
import LocationsServiceAPI from '../../API/Services/LocationServiceAPI';
import { IVoucherItemDto } from '../../API/Interfaces/IVoucherDtos';

const LocationVouchers = () => {
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();
	const tableRef = useRef();
	const { id } = useParams<{ id: string }>();
	const errorDialog = (message?: string) =>
		enqueueSnackbar(`${t('common.errorOccured')}${message ? ': ' : ''}${message && message}`, { variant: 'error' });

	const headers: Array<Column<IVoucherItemDto>> = [
		{
			title: t('locations.table.nameHeader'),
			field: 'title',
			defaultSort: 'asc',
		},
		{
			title: t('location.headers.voucherAmount'),
			sorting: false,
			render: (rowData) => (
				<span>
					{rowData.minPaymentAmount && rowData.maxPaymentAmount
						? (rowData.minPaymentAmount)/100 + ' - ' + (rowData.maxPaymentAmount)/100
						: '≥ ' + (rowData.minPaymentAmount)/100} PLN
				</span>
			),
		},
	];

	const EntityActions: IOverrideEntityActions<IVoucherItemDto, IVoucherItemDto> = {
		api: LocationsServiceAPI,
		presetDataCallback: (data: any) => {
			return data;
		},
		getTableData: async function (query: Query<IVoucherItemDto>) {
			const result: QueryResult<IVoucherItemDto> = {
				data: [],
				page: 0,
				totalCount: 0,
			};
			const request: ISearchBaseDto = {
				itemsPerPage: query.pageSize,
				pageNumber: query.page ? query.page + 1 : 1,
				searchPhrase: query.search,
				sortColumn: '',
				sortDirection: '',
			};

			if (query.orderBy) request.sortColumn = query.orderBy.field as string;

			if (query.orderDirection) request.sortDirection = query.orderDirection;

			try {
				const response = await EntityActions.api.GetVoucherDefinitions(id, request);

				if (response.success) {
					result.data = response.data.items;
					result.page = response.data.currentPage - 1;
					result.totalCount = response.data.totalItemsCount;

					return result;
				} else {
					let message = t(`errorCodes.${response.errors[0].errorCode}`);
					enqueueSnackbar(`${t('common.errorOccured')}: ${message}`, { variant: 'error' });
				}
			} catch (e) {
				errorDialog(e.message);
			}
			return result;
		},
	};

	const tableProps: any = {
		columns: headers,
		options: { paging: true },
	};

	let entityPageProps = {
		tableRef: tableRef,
		EntityActions: EntityActions,
		headers: headers,
		pageTitle: t('location.tabs.vouchers'),
		tableProps: tableProps,
		disableAddNew: true,
	};

	return <EntityPage {...entityPageProps} />;
};

export default LocationVouchers;
